import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import structure from '../../structure';
import Navigation from '../Navigation';
import loadAsync from '../loadAsync';
import Header from '../Header';

const Home = ({ match }) => (
  <div className="app">
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      pauseOnHover
    />
    <Header />
    <div className="app-body">
      <Navigation structure={structure} />
      <div className="main">
        <div className="container-fluid my-4">
          {structure.routes.map(route => (
            <Route
              key={route.path}
              exact={route.exact}
              path={match.path + route.path}
              component={loadAsync(route.component.name)}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

Home.propTypes = {
  match: PropTypes.object.isRequired
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/component.js